import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

import { changeItemOwner } from '../itemOwner/itemOwnersSlice';

export const fetchItems = createAsyncThunk(
  'items/get',
  async (data, thunkAPI) => {
    try {
      const currentState = thunkAPI.getState();

      /*
      Expected in format:
      {
        searchOperator: 'AND',
        params: [
          {
            field: 'price',
            operator: 'largerThan',
            value: 10
          },
          {
            field: 'itemFamily',
            operator: 'oneOf',
            value: ['IF-124']
          }
        ]
      }
      */
      let apiData = {};
      if(data) {
        apiData = {
          includeManual: true, // To get manual image overrides with data
          searchOperator: data.activeOperator,
          params: data.activeFilters.map(row => ({
            field: row.field,
            operator: row.operation,
            value: row.value
          }))
        };
      }

      const response = await api.getItems(currentState.itemOwners.selected, apiData);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('ERROR: items/get', e.message);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  items: [],
  status: 'idle',
  error: null,
};

export const itemsSlice = createSlice({
  name: 'items',
  initialState,
  reducers: {
    clearRequestState: (state, action) => {
      state.error = null;
      state.status = 'idle';
    },
    reset: (state, action) => {
      return initialState;
    }
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchItems.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.items = action.payload?.items || [];
    },
    [fetchItems.pending]: (state, action) => {
      state.status = 'loading';
      state.error = null;
    },
    [fetchItems.rejected]: (state, action) => {
      let message = 'INTERNAL_SERVER_ERROR';

      if(typeof action.payload === 'string') {
        // error message
        message = action.payload;
      } else if(action.payload.messages.length) {
        message = action.payload.messages.join(', ');
      }


      state.status = 'failed';
      state.error = {
        message: message,
        errors: action.payload.result?.errors
      };
    },

    [changeItemOwner.fulfilled]: (state, action) => {
      // Clear state if owner changes
      return initialState;
    }
  }
});

export const { clearRequestState, reset } = itemsSlice.actions;

export const selectItems = state => state.items;

export default itemsSlice.reducer;
